<template>
  <div style="width: 600px; overflow: hidden">
    <el-dialog v-dialogDrag :title="$t('message.title.saveAs')" :visible.sync="saveAsDialogVisible" class="dialog"
      width="50%" @close="closeSaveAs" :append-to-body="true">
      <div v-loading='saveAsLoading' style="padding: 20px;">
        <el-form ref="addFormRef" :model="addForm" label-width="120px" :rules="addFormRoles">
          <el-form-item :label="$t('message.table.projectName')" prop="name">
            <el-input v-model="addForm.name" size="small"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.table.des')" prop="description">
            <el-input type="textarea" v-model="addForm.description" size="small"></el-input>
          </el-form-item>
          <el-form-item :label="$t('message.button.projectStatus')">
            <el-select v-model="templateVal" size="small">
              <el-option v-for="item in statusList" :key="item.value" :label="item.label" :value="item.value">
              </el-option>
            </el-select>
          </el-form-item>
        </el-form>


        <div slot="footer" class="dialog-footer">
          <el-button @click="saveAsDialogVisible = false" size="small">{{
            $t("message.button.cancel")
          }}</el-button>
          <el-button type="primary" @click="addSaveAs" size="small">{{
            $t("message.button.affirm")
          }}</el-button>
        </div>
      </div>
    </el-dialog>

    <!-- <el-button
      icon="el-icon-check"
      :disabled="signoffButton"
      size="small"
      @click="enableApproveWindow"
    >
      {{ $t("message.title.approve") }}
    </el-button> -->

    <!-- <el-button
      style="margin: 0 10px"
      icon="el-icon-close"
      :disabled="signoffButton"
      size="small"
      @click="enableRejectWindow"
      >{{ $t("message.title.reject") }}
    </el-button> -->

    <el-dropdown :disabled="signoffButton || !isExecuter || nextStateBtnDisable"
      :class="StatusBtn || !isExecuter || nextStateBtnDisable ? 'next-status-btn' : ''" split-button
      v-loading.fullscreen.lock="fullscreenLoading" @click="NextState" size="small" style="margin-left: 10px"
      @command="goToState">
      <span>
        {{ $t("message.title.manualNextStatus") }}
      </span>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item v-for="status in statusInfo" :key="status.id" :statusType="status.statusType"
          :command="status.id" :disabled="status.hasPriv == 0 || !isExecuter">{{ status.name }}</el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>

    <el-dropdown placement="bottom" style="margin-left: 10px">
      <el-button size="small">
        {{ $t("message.button.actions")
        }}<i class="el-icon-arrow-down el-icon--right"></i>
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item @click.native="addPause" :disabled="pause_show || !userDisable || !isExecuter"
          v-if="!pause_show || !userDisable">
          {{ $t("message.button.pause") }}
        </el-dropdown-item>
        <el-dropdown-item @click.native="addCancelPause" :disabled="cancelPause_show || !userDisable || !isExecuter"
          v-if="!cancelPause_show || !userDisable">
          {{ $t("message.button.cancelPause") }}
        </el-dropdown-item>
        <!-- <el-dropdown-item @click.native="addCancel" :disabled="cancelPause_show" v-if="!cancelPause_show"> -->
        <el-dropdown-item @click.native="addCancel" :disabled="cancelPause_show || !userDisable || !isExecuter"
          v-if="!cancelPause_show || !userDisable">
          {{ $t("message.button.closeProject") }}
        </el-dropdown-item>
        <el-dropdown-item @click.native="addFavorite">
          {{ $t("message.button.bookmark") }}
        </el-dropdown-item>
        <el-dropdown-item @click.native="removeFavorite">{{ $t("message.button.cancelBookmark") }}
        </el-dropdown-item>
        <el-dropdown-item :disabled="disable_show || !userDisable || !removeBtnPriv || !isExecuter"
          @click.native="deleteItem" v-show="isRoot">{{ $t("message.button.delete") }}
        </el-dropdown-item>
        <el-dropdown-item v-if="!milepost" @click.native="saveAsDialogVisible = true">
          {{ $t("message.button.saveAs") }}
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
    <slot></slot>
  </div>
</template>

<script>
import axios from "axios";
import { dialogDrag } from '@/utils/directive'
import Vue from "vue";
Vue.directive('dialogDrag', dialogDrag);
export default {
  data() {
    return {
      status: "", //当前状态
      workflowId: "", //当前工作流

      changeInfo_All: [], //change的所有信息
      change_value: "0", //change选中的信息
      change_to_child: "", //向子组件传送change信息
      updateWorkflowTable: "", //向子组件传送change信息
      saveAsDialogVisible: false, //另存为展示框
      milepost: false,//关卡里程碑另存为按钮不显示

      addForm: {},
      addFormRoles: {
        name: [
          {
            required: true,
            message: this.$t("message.tips.inputName"),
            trigger: "blur",
          },
          {
            min: 3,
            max: 25,
            message: this.$t("message.warning.length_101"),
            trigger: "blur",
          },
        ],
      },

      page_one: [],
      tabList: [],
      loading: true,
      deletePriv: false,
      version: "",
      signoffButton: true,
      userInfo: {},
      approveWindow: false,
      rejectWindow: false,
      signoffComments: "",
      rejectComments: "",
      currentUserId: "",
      currentUserLoginId: "",
      isMilepost: false,

      fullscreenLoading: false,
      StatusBtn: false,
      templateVal: "3",

      statusInfo: [], //状态选项
      pause_show: true,
      disable_show: true,
      cancelPause_show: true,
      isRoot: false,
      userDisable: false,
      isDirector: false,
      isExecuter: false,
      removeBtnPriv: false,
      saveAsLoading: false,
      nextStateBtnDisable: false,
    };
  },
  props: ["titleInfo", "statusList", "disableDel", "directorDisable"],
  mounted() {
    //console.log(this.title);
    // this.getSignInfo();
    // this.getAllStatus();
  },
  methods: {
    changeProjectSpecialStatus(statusId) {
      var stateVal = {
        projectId: this.$store.state.objectId.id,
        specialStatus: statusId,
      };
      axios
        .post("/ppm/project/changeProjectSpecialStatus", stateVal)
        .then((res) => {
          if (res.data.code == 200) {
            this.$message({
              message: res.data.message,
              type: "success",
            });
            this.getAllStatus();
            this.getProjectStatus();
            this.$emit("reloadNewPage", true);
          }
        });
    },
    addPause() {
      this.changeProjectSpecialStatus(1);
      //this.$store.commit("setReloadProjectBtnDisable", true);
      this.$store.commit("setAllProjectBtnDisable", true);
    },
    addCancelPause() {
      this.changeProjectSpecialStatus(0);
      //this.$store.commit("setReloadProjectBtnDisable", false);
      this.$store.commit("setAllProjectBtnDisable", false);
    },
    addCancel() {
      //console.log("123");
      this.$confirm(
        this.$t("message.confirm.cancelData"),
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          this.changeProjectSpecialStatus(2);
          this.$store.commit("setAllProjectBtnDisable", true);
        })
        .catch(() => { });
    },
    NextState() {
      if (!this.isExecuter || this.nextStateBtnDisable) { return false };
      this.statusInfo.length && this.updateState(this.statusInfo[0].id);
      this.$emit('reloadPage')
    },
    goToState(num) {
      //console.log(num);
      this.updateState(num);
    },
    updateState(stateId) {
      let stateVal = {
        projectId: this.$store.state.objectId.id,
        targetStatusId: stateId,
      };
      axios.post("/ppm/project/changeProjectStatus", stateVal).then((res) => {
        if (res.data.code == 200) {
          this.$message({
            message: this.$t("message.success.actions"),
            type: "success",
          });
          this.getAllStatus();
          this.$emit("reloadNewPage", true);
        }
      });
    },
    checkDelPriv(e) {
      const arr = JSON.parse(sessionStorage.getItem("userContext")).privs;
      const privsArr = arr.map((i) => {
        return i.type;
      });
      if (privsArr.indexOf(25) != -1) {
        this.deletePriv = true;
      };
    },
    enableApproveWindow() { },
    enableRejectWindow() { },
    getAudit() {
      var change_info = this.$store.state.change_info;
      axios
        .post("/pmdm/changes/checkStatus", {
          //
          ... this.$store.state.objectId,

          version: this.version,
          currentStatus: this.title_currentStatusId,
          currentStatusType: this.title_currentStatusType,
          nextStatus: this.title_nextStatusId,
          nextStatusType: this.title_nextStatusType,
          workflowId: this.title_workflowId,
          changeId: change_info.changeId,
          changeClassId: change_info.changeClassId,
          changeSubClassId: change_info.changeSubClassId,
        })
        .then((res) => {
          //console.log(res);
          if (res.data.object.codeId == 20004) {
            //this.audit_dialog = true;
            this.audit_dialog = true;
            this.fullscreenLoading = false;
            this.mandatoryField = true;
            //console.log(res.data.object.error);
            if (res.data.object.error.length !== 0) {
              this.audit_dialog_error = true;
              this.audit_add = false;
              this.audit_erro = res.data.object.error;
              this.nextStatusBtn = true;
            } else {
              this.audit_dialog_error = false;
            }
            if (res.data.object.warning.length !== 0) {
              this.audit_dialog_warning = true;
              this.audit_warning = res.data.object.warning;
              this.nextStatusBtn = false;
            } else {
              this.audit_dialog_warning = false;
            }
            this.updateUsers();
            this.loadUser();
          }
          if (res.data.object.codeId == 200) {
            //console.log(this.title_nextStatusType);
            this.fullscreenLoading = false;
            if (
              this.title_nextStatusType == 2 ||
              this.title_nextStatusType == 3
            ) {
              this.audit_dialog = false;
              this.mandatoryField = true;
              this.audit_add = true;
              this.updateUsers();
              this.loadUser();
            } else {
              //this.$refs.submitClick.click();
              this.submitAudit();
            }
          }
        })
        .catch(function (error) {
          console.log(error);
        });
    },
    //收藏、取消收藏、删除
    addFavorite() {
      let description_ = "";
      //console.log(this.title);
      if (this.title.des) {
        description_ = ":" + this.title.des;
      }
      this.addFavoriteInCommon({
        baseClassId: this.Constants.projectBaseClassId,
        number: this.title.name + description_,
        ... this.$store.state.objectId,
        //id: this.$store.state.objId_,
      });
    },
    removeFavorite() {
      // console.log("removeFavorite");
      this.removeFavoriteInCommon({
        baseClassId: this.Constants.projectBaseClassId,
        number: this.title.name,
        ... this.$store.state.objectId,
        //id: this.$store.state.objId_,
      });
    },
    deleteItem() {
      this.$confirm(
        this.$t("message.confirm.deleteObject"),
        this.$t("message.tips.tip"),
        {
          confirmButtonText: this.$t("message.button.affirm"),
          cancelButtonText: this.$t("message.button.cancel"),
          type: "warning",
        }
      )
        .then(() => {
          return this.sendDelProject();
        }).then(_ => {
          return this.removeRelationshipValueAPI();
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: this.$t("message.tips.deleteCancel"),
          });
        });
    },
    removeRelationshipValueAPI() {
      const systemCode = window.sessionStorage.getItem("systemCode") || "";
      if (systemCode.indexOf('medlinket') === -1) {
        return
      }
      const { id: projectId, classId } = this.$store.state.objectId
      return axios.post(`project/removeRelationshipValue`, [{ projectId, classId }])
    },
    sendDelProject() {
      axios
        .post(
          "/ppm/project/softDelScheduleByRootId?rootId=" +
          this.$store.state.objectId.id
        )
        .then((res) => {
          if (res.data.code == 200) {
            this.$message.success(res.data.message);
            // this.$emit("deletePage");
            const { id } = this.$store.state.objectId
            const obj = { rootId: id }
            this.$store.dispatch("delPro", obj);
            const item = this.$store.state.showingTabsInHome.at(-1);
            console.log(item);


            const nextPush = {
              path: item.path,
              query: item.query,
            };
            this.$router.push(nextPush);


          } else {
            this.$message({
              type: "info",
              message: this.$t("message.error.delete"),
            });
          }
        });
    },
    saveAsTemplete() { },
    closeSaveAs() {
      //this.$refs.addFormRef.clearValidate();
      this.addForm = {};
      this.templateVal = "3";
    },
    addSaveAs() {
      this.saveAsLoading = true;
      this.$refs.addFormRef.validate((valid) => {
        if (!valid) {
          this.saveAsLoading = false;
          return;
        } else {
          let obj = {
            ... this.$store.state.objectId,
          };
          this.addForm.objectId = obj;
          //对象生成模板 1生成模板，2生成项目
          this.addForm.createType = 1;
          this.addForm.template = this.templateVal;

          this.$http.post("/ppm/project/createTempleteOrObj", this.addForm).then((res) => {
            console.log(res);
            if (res.data.code == 200) {
              //this.$message.success(res.data.message)
              this.$message.success(this.$t("message.success.actions"));
              // this.btnLoading = false;
              this.addForm = {};
              this.templateVal = "3";
              //this.$store.commit("setClassId", res.data.object.classId);
              //this.$store.commit("setObjID", res.data.object.id);
              //this.$store.commit("setSubClassId", res.data.object.subclassId);
              this.$store.commit("setQuickCreate", {});
              // this.$router.push("/titleBlock");
              let obj = {
                itemClassId: res.data.object.classId,
                itemId: res.data.object.id,
                itemSubClassId: res.data.object.subclassId,
                '0': res.data.object.name
              };
              // this.getRouteLink(obj);
              this.saveAsLoading = false;
              this.saveAsDialogVisible = false;
              this.$emit("saveRoute", obj);
            } else {
              this.saveAsLoading = false;
            }
          });
        }
      });
    },

    getAllStatus() {
      this.statusInfo = [];
      axios
        .get(
          "/ppm/project/getProjectStatusListById?id=" + this.$store.state.objectId.id
        )
        .then((res) => {
          let projectStatusList = res.data.object.projectStatusList;
          this.statusInfo = [...projectStatusList]
          this.StatusBtn = !projectStatusList.length
          this.signoffButton = !projectStatusList.length
          let currectStatus = res.data.object.currectStatus;
          if ([3, 4].includes(currectStatus.statusType)) {
            this.nextStateBtnDisable = true;
            this.$store.commit("setReloadProjectBtnDisable", true);
          } else {
            let nextOrder = currectStatus.statusOrder + 1;
            this.nextStateBtnDisable = projectStatusList.length && !projectStatusList.some(i => i.hasPriv && i.statusOrder == nextOrder);
            this.$store.commit("setReloadProjectBtnDisable", false);
          };
          this.getExecuters();
        });
    },

    getProjectStatus() {
      axios.get(
        "/ppm/project/getProjectSpecialStatus?id=" + this.$store.state.objectId.id
      ).then((res) => {
        console.log(res);
        this.isRoot = res.data.object.specialProjectVo.isRoot;
        const specialState = res.data.object.specialProjectVo.specialState;

        let isSupAdmin = this.$store.state.isSuperAdmin;
        if (this.isRoot || isSupAdmin) {
          this.pause_show = !!specialState;
          this.disable_show = specialState == 2 ? false : !!specialState;
          this.cancelPause_show = !!(specialState > 1);
        };
        // console.log(this.pause_show);
        let milepost_ = res.data.object.specialProjectVo.subClassId;//关卡和里程碑不需要另存为按钮
        if (milepost_ == 3010202 || milepost_ == 3010201) {
          this.milepost = true;
        };

        this.$store.commit("setReloadProjectBtnDisable", !!specialState);

        // if (res.data.code == 200) {
        //   this.isRoot = !!res.data.object.specialProjectVo.isRoot;
        //   if (res.data.object.specialProjectVo.isRoot == 1) {
        //     if (res.data.object.specialProjectVo.specialState == 0) {
        //       this.pause_show = false;
        //       this.cancelPause_show = false;
        //       this.cancel_show = false;
        //       this.$store.commit("setReloadProjectBtnDisable", false);
        //     } else if (res.data.object.specialProjectVo.specialState == 1) {
        //       this.pause_show = true;
        //       this.cancelPause_show = false;
        //       this.cancel_show = false;
        //       this.$store.commit("setReloadProjectBtnDisable", true);
        //     } else {
        //       this.pause_show = true;
        //       this.cancelPause_show = true;
        //       this.cancel_show = true;
        //       this.$store.commit("setReloadProjectBtnDisable", true);
        //     }
        //   } else {
        //     this.pause_show = true;
        //     this.cancelPause_show = true;
        //     this.cancel_show = true;
        //     if (res.data.object.specialProjectVo.specialState == 0) {
        //       this.$store.commit("setReloadProjectBtnDisable", false);
        //     } else {
        //       this.$store.commit("setReloadProjectBtnDisable", true);
        //     }
        //   }
        // }
      });
    },
    getExecuters() {
      var obj_get = {
        ... this.$store.state.objectId,

      };
      axios.get(`ppm/project/getExecuters${this.params(obj_get)}`).then((res) => {
        //this.isExecuter = true;
        let userList = [];
        res.data.object.executers.map(item => {
          userList.push(item.id);
        });
        let userId = window.sessionStorage.getItem("userContext");
        userId = JSON.parse(userId).id;
        let userIndex_ = userList.indexOf(userId);
        //console.log(userIndex_);
        this.$store.commit("setIsProjectExecuters", userIndex_);
        let isSupAdmin = this.$store.state.isSuperAdmin;
        if (isSupAdmin) { this.userDisable = true; this.removeBtnPriv = true };//超级管理员控制删除等按钮
        let projectCreatedBy = this.$store.state.projectCreatedBy;

        const projectAdmin = this.$store.state.isProjectDirector;

        console.log(projectAdmin);


        if (this.isDirector || userIndex_ !== -1 || userId == projectCreatedBy || projectAdmin || isSupAdmin) {//判断是不是项目经理,项目执行者，项目负责人，操作下一状态
          if (this.userDisable) {

            this.isExecuter = true;
          } else {

            this.isExecuter = false;
          };
        } else {
          this.isExecuter = false;
        };
        console.log(this.isExecuter);
      });
    },
    queryData(e) {
      var priv_ = this.getUserContextPriv();
      let subClass_Id = this.$store.state.objectId.subClassId;
      // console.log(subClass_Id);
      for (let i = 0; i < priv_.length; i++) {
        if (priv_[i].classId == subClass_Id) {
          if (priv_[i].type == 4) {
            console.log("123");
            this.removeBtnPriv = true;
          };
        };
      };
      this.userDisable = e
      this.removeBtnPriv = e
      // console.log(this.pause_show);
      // console.log(this.userDisable);
      // console.log(this.removeBtnPriv);
    },
    director(e) {
      console.log(e);
      if (e) {
        this.isDirector = true;
      } else {
        this.isDirector = false;
      }
    }
  },
  created() {
    // this.getAllStatus();
    this.getProjectStatus();
    this.getExecuters();
  },
  computed: {
    vxeReloadTabPage() {
      return this.$store.state.reloadTabPage;
    },
  },

  watch: {
    titleInfo: function (n, o) {
      // console.log(n);
      this.title = n;
      this.signoffButton = this.title.status == -1;
      this.getAllStatus();
    },
    statusList: function (n, o) {
      console.log(n);
    },
    vxeReloadTabPage: {
      handler(val) {
        //console.log(val);
        this.getAllStatus();
      },
      deep: true,
      immediate: true,
    },
    disableDel: function (a, b) {
      this.queryData(a);
    },
    directorDisable: function (a, b) {
      this.director(a);
    },
  },
};
</script>

<style scoped>
.dialog-footer {
  float: right;
}
</style>